import { render, staticRenderFns } from "./PageEmployee.vue?vue&type=template&id=72e0d5f1&scoped=true&"
import script from "./PageEmployee.vue?vue&type=script&lang=js&"
export * from "./PageEmployee.vue?vue&type=script&lang=js&"
import style0 from "./PageEmployee.vue?vue&type=style&index=0&id=72e0d5f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e0d5f1",
  null
  
)

export default component.exports